/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menueditorreadhint3Inputs */

const en_menueditorreadhint3 = /** @type {(inputs: Menueditorreadhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read from your files. Check every line before you publish.`)
};

const de_menueditorreadhint3 = /** @type {(inputs: Menueditorreadhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aus deinen Dateien gelesen. Prüf jede Zeile, bevor du veröffentlichst.`)
};

/**
* | output |
* | --- |
* | "Read from your files. Check every line before you publish." |
*
* @param {Menueditorreadhint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditorreadhint3 = /** @type {((inputs?: Menueditorreadhint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditorreadhint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditorreadhint3(inputs)
	return de_menueditorreadhint3(inputs)
});
export { menueditorreadhint3 as "menuEditorReadHint" }